module.exports = __webpack_public_path__ + "static/media/cta-arrow-prev-green.e2262424.svg";